// extracted by mini-css-extract-plugin
export default {"logo_txt":"style_logo_txt__oR4gm","container":"style_container__3XFzL","img":"style_img__flyRa","subtitle":"style_subtitle__SKYlK"};